import { get } from 'lodash';

export const getProfileUrls = (state) => state.profileUrls;

export const getProfileUrlByUser = (state, user) => get(getProfileUrls(state), [user.siteMemberId]);
